import { render, staticRenderFns } from "./AssignOrdersTeam.vue?vue&type=template&id=490ec2ac"
import script from "./AssignOrdersTeam.vue?vue&type=script&lang=js"
export * from "./AssignOrdersTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports